<template>
   <v-data-table v-resize="onResize" 
    :footer-props="{
        itemsPerPageOptions:[-1]
    }"
    fixed-header
    :headers="headers"
    :items-per-page="-1" 
    :items="items"
    no-data-text="측정된 자료가 없습니다."
    item-key="date"
    :sort-by="tablesortBy"
    :sort-desc="tablesortDesc"
    single-select
    :class="{mobile: isMobile}"
    hide-default-footer
    hide-default-header
    class="v-table"
  >
    <template v-slot:header>
      <thead v-if="!isMobile">
        <tr>
          <th rowspan="2" @click="toggleSort('date')">등급판정일자</th>
          <th rowspan="2">1+</th>
          <th rowspan="2">1</th>
          <th rowspan="2">2</th>
          <th rowspan="2">등외</th>
          <th colspan="2" class="text-center group-header">평균도체중</th>
          <!-- <th rowspan="2">도체중 <br/>(등급)</th>
          <th rowspan="2">도체중 <br/>(등외)</th> -->
          <th colspan="3" class="text-center group-header">성별</th>
          <th rowspan="2">등지방</th>
        </tr>

        <tr>
          <th class="sub-header" style="top:40px !important;">등급</th>
          <th class="sub-header" style="top:40px !important;">등외</th>

          <th class="sub-header" style="top:40px !important;">암</th>
          <th class="sub-header" style="top:40px !important;">수</th>
          <th class="sub-header" style="top:40px !important;">거세</th>
        </tr>
      </thead>
    </template>

    <template v-slot:item= "{ item }">
      <tr v-if="!isMobile" >
        <td>{{ item.date }}</td>
        <td>{{ item.cnt_grade["1+"] }}</td>
        <td>{{ item.cnt_grade["1"] }}</td>
        <td>{{ item.cnt_grade["2"] }}</td>
        <td>{{ item.cnt_grade.etc }}</td>

        <td>{{ item["kg+"].ave }}</td>
        <td>{{ item["kg-"].ave }}</td>

        <td>{{ item.cnt_sex.female }}</td>
        <td>{{ item.cnt_sex.male }}</td>
        <td>{{ item.cnt_sex.xmale }}</td>

        <td>{{ item.totalthick }}</td>
      </tr>
      <tr v-else class="mobile_tr">
        <td class="mb_table">
            <div class="date mt-2">
              <div class="flex-title"> 발급일자</div>
              <div> {{ item.date }}</div>
            </div>

            <div class="flex">
              <div class="flex-title weight">등급판정</div>
              <div class="flex">
                <div class="flex-content">
                  <div class="weight">1+</div>
                  <div> {{ item.cnt_grade["1+"] }}두  </div>
                </div>

                <div class="flex-content">
                  <div class=" weight">1</div>
                  <div >{{ item.cnt_grade["1"]  }}두   </div>
                </div>

                <div class="flex-content">
                  <div class="weight">2</div>
                  <div> {{ item.cnt_grade["2"] }}두   </div>
                </div>

                <div class="flex-content">
                  <div class="weight">등외</div>
                  <div> {{ item.cnt_grade.etc }}두   </div>
                </div>

              </div>

              <div class="line-table"></div>

              <div class="flex">
                <div class="flex-title weight">도체중량 (등급)</div>

                <div class="flex">
                  <div class="flex-content">
                    <div class="weight"></div>
                    <div>  {{ item['kg+'].ave  }}kg  </div>
                  </div> 
                </div>
              </div>

              <div class="line-table"></div>

              <!-- 여기 수정 -->
              <div class="flex">
                <div class="flex-title weight">도체중량 (등외)</div>

                <div class="flex">
                  <div class="flex-content">
                    <div class="weight"></div>
                    <div>  {{ item['kg-'].ave  }}kg  </div>
                  </div> 
                </div>
              </div>

              <div class="line-table"></div>

              <div class="flex">
                <div class="flex-title">성별</div>

                <div class="flex">
                  <div class="flex-content">
                    <div class="weight">암</div>
                    <div> {{ item.cnt_sex.female }}두 </div>
                  </div>

                  <div class="flex-content">
                    <div class="weight">수</div>
                    <div> {{ item.cnt_sex.male }}두 </div>
                  </div>

                  <div class="flex-content">
                    <div class="weight">거세</div>
                    <div> {{ item.cnt_sex.xmale }}두 </div>
                  </div>
                </div>
                
                <div class="line-table"></div>

                <div class="flex">
                  <div class="flex-title weight">등지방두께</div>

                  <div class="flex">
                    <div class="flex-content">
                      <div class="weight"></div>
                      <div>  {{ item.totalthick  }}cm  </div>
                    </div> 
                  </div>
                </div>
              </div>
            </div>
          </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "CustomTable",
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    sortBy: {
      type: String,
      default: "date",
    },
    sortDesc: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isMobile: false,
      tablesortBy: this.sortBy,
      tablesortDesc: this.sortDesc,
    };
  },
  methods: {
    updateSortBy(value) {
      this.tablesortBy = value;
      this.$emit("update:sortBy", value); 
    },
    updateSortDesc(value) {
      this.tablesortDesc = value;
      this.$emit("update:sortDesc", value);
    },
    toggleSort(column) {
      if (this.tablesortBy === column) {
        this.tablesortDesc = !this.tablesortDesc; 
      } else {
        this.tablesortBy = column;
        this.tablesortDesc = false; 
      }

      this.$emit("update:sortBy", this.tablesortBy);
      this.$emit("update:sortDesc", this.tablesortDesc);
    },
    addCommas(num) {
      if (typeof num === "number") {
        return num.toLocaleString();
      }
      return num;
    },
    onResize() {
      this.isMobile = window.innerWidth < 769;
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped lang="scss">
@import '../../../style/table_mb.scss';
.v-data-table th {
  text-align: center !important;
  vertical-align: middle !important;
}
.v-table td {
  text-align: center;
  vertical-align: middle;
}

:deep(.v-data-table__wrapper) {
  max-height: 45vh;
  overflow-y: auto;
  display: block;
}

:deep(.v-table thead tr:first-child th) {
  position: sticky;
  top: 0;
  z-index: 20;
  background-color: #005b96;
  color: white;
  height: 40px;
  text-align: center;
}


:deep(.v-table thead th.sub-header) {
  position: sticky;
  top: 40px !important; 
  z-index: 19;
  background-color: #005b96;
  color: white;
  height: 40px;
  text-align: center;
}



</style>
